import { MutationTree, Store } from 'vuex';
import {
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    LOGOUT,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_ERROR,
    ME_SUCCESS,
    LOGIN, FETCH_ACCOUNT_SUCCESS, FETCH_ACCOUNT_ERROR
} from './constants';
import { AuthState, LoginReponse, MeResponse } from '../types';

import { vm } from '@/main';

const mutations = {
    [LOGIN](state: AuthState, data: LoginReponse) {
        state.error = false;
        state.loading = true;
    },
    [LOGIN_SUCCESS](state: AuthState, data: LoginReponse) {
        state.token = data.token;
        state.refresh_token = data.refresh_token;
        state.loading = false;
        state.error = false;
        vm.$router.push('/lobby');
    },
    [LOGIN_ERROR](state: AuthState) {
        state.user = undefined;
        state.error = true;
        state.loading = false;
        setTimeout(() => {
            state.error = false;
        }, 5000);
    },
    [REFRESH_TOKEN_SUCCESS](state: AuthState, data: LoginReponse) {
        state.token = data.token;
        state.refresh_token = data.refresh_token;
        state.error = false;
    },
    [REFRESH_TOKEN_ERROR](state: AuthState) {
        state.user = undefined;
        state.token = '';
        state.refresh_token = '';
        state.error = true;
        vm.$router.push('/login');
    },
    [LOGOUT](state: AuthState) {
        state.token = '';
        state.user = undefined;
        state.error = false;
        state.loading = false;
    },
    [ME_SUCCESS](state: AuthState, data: any) {
        // @ts-ignore
        state.user = {
            username: data.username,
            email: data.email,
            accountId: data.accountId,
            id: data.id,
        }
    },
    [FETCH_ACCOUNT_SUCCESS](state: AuthState, data: any) {
        // @ts-ignore
        state.account.moneyCurrency = data.account.moneyCurrency;
        // @ts-ignore
        state.account.moneyAmount = data.account.moneyAmount;
    },
    [FETCH_ACCOUNT_ERROR](state: AuthState) {
        // TODO
    },
} as MutationTree<AuthState>;

export default mutations;
